import * as Styles from './styles'

type IlustrationBoxProps = {
  src?: string
  percentage?: number
}

export const IlustrationBox = ({ src, percentage }: IlustrationBoxProps) => {
  return (
    <Styles.IlustrationContainer data-testid="upskill-illustration-box-progress">
      <Styles.IlustrationImageContainer>
        <Styles.IlustrationImage src={src} />
        <Styles.IlustrationProgressCircle>
          <Styles.IlustrationProgressInnerCircle percentage={percentage || 0}>
            <Styles.IlustrationProgressText>{percentage}%</Styles.IlustrationProgressText>
          </Styles.IlustrationProgressInnerCircle>
        </Styles.IlustrationProgressCircle>
      </Styles.IlustrationImageContainer>
    </Styles.IlustrationContainer>
  )
}
